import React from 'react';
import Dialog from '@rio-cloud/rio-uikit/lib/es/Dialog';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import CM4LogRequest, { CM4LogRequestForm } from '~/features/deviceLogs/components/logRequest/CM4LogRequest';
import CM4RequestLogButton from '~/features/deviceLogs/components/logRequest/CM4RequestLogButton';
import { FormProvider, useForm } from 'react-hook-form';
import moment from 'moment';
import { isDiagLogFileManagerSelector } from '~/features/user/selectors/permissionSelectors';
import { createCustomPresets } from '~/features/base/utils/customPresets';
import { useLimitedDeviceSerials } from '~/features/devices/hooks/useLimitedDeviceSerials';

interface CreateLogRequestInBulkDialogProps {
    onHide: () => void;
}

const MAX_DEVICES = 15;

const CreateLogRequestInBulkDialog: React.FC<CreateLogRequestInBulkDialogProps> = ({ onHide }: CreateLogRequestInBulkDialogProps) => {
    const isDeviceLogUser = useSelector(  isDiagLogFileManagerSelector);
    const serialNumbers = useLimitedDeviceSerials(MAX_DEVICES);


    const renderBody = () => {

        const presetsWithoutLast30 = createCustomPresets(false).filter(p => p.id !== 30);
        return (
            <CM4LogRequest customPresets={presetsWithoutLast30} serialNumberList={serialNumbers} isDeviceLogsUser={true}
                           requestDisabled={false}
                           maxDaysOfLogs={10}
                           onFormSubmit={onHide}
                           showDeviceListForm hideRequestButton/>
        );
    };
    const renderFooter = () => {
        return <div className='btn-toolbar justify-content-end'>
            <CM4RequestLogButton isUserAllowed={isDeviceLogUser}/>
        </div>;
    };
    const methods = useForm<CM4LogRequestForm>({
        defaultValues: {
            dateInput: {
                startValue: moment().startOf('day'),
                endValue: moment(),
            },
            serialNumberList: serialNumbers,
            requestedSystem: [],
        },
        mode: 'onChange',
    });
    return (
        <FormProvider {...methods}>
        <Dialog
            show={true}
            showCloseButton={true}
            onHide={onHide}
            bodyClassName={'visible'}
            title={<FormattedMessage id='intl-msg:createLogRequestInBulk'/>}
            body={renderBody()}
            footer={renderFooter()}

        />
        </FormProvider>
    );
};

export default CreateLogRequestInBulkDialog;
